import { useEffect, useState } from "react";
import { notification } from "antd";

import {
  IInterviewGuide,
  InterviewGuideHttpService,
} from "@/modules/assessments/services/interview-guide-http.service";
import { getFriendlyErrorMessage } from "@/shared/services/http";

export function useGetInterviewGuideHook(templateId: number | null) {
  const [guide, setGuide] = useState<IInterviewGuide | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (templateId === null) {
      setGuide(null);
      return;
    }

    let active = true;
    const id = templateId;

    async function fetchGuide() {
      try {
        setIsLoading(true);
        const data = await InterviewGuideHttpService.getInterviewGuide(id);
        if (active) setGuide(data);
      } catch (error) {
        if (active) {
          const message = getFriendlyErrorMessage(error) ?? "Failed to load the interview guide for this template.";
          notification.error({ message });
        }
      } finally {
        if (active) setIsLoading(false);
      }
    }

    fetchGuide();

    return () => {
      active = false;
    };
  }, [templateId]);

  return { guide, isLoading };
}
